module.exports = __webpack_public_path__ + "img/img_logo.3d34c520.png";